import React from "react";
import Modal from "react-bootstrap/Modal";
import { StaticImage } from "gatsby-plugin-image";
import PropTypes from "prop-types";

// css
import * as styles from "./AlertPopUp.module.css";

const propTypes = {
  text: PropTypes.string,
  showAlertPopUp: PropTypes.bool,
  onHideAlertPopUpModal: PropTypes.func,
};

const defaultProps = {
  text: "Thank you for registering for launch invite!",
  showAlertPopUp: false,
  onHideAlertPopUpModal: () => {},
};

const AlertPopUp = props => {
  return (
    <div className="alertMsg">
      <Modal
        size="sm"
        show={props.showAlertPopUp}
        onHide={props.onHideAlertPopUpModal}
        backdrop="static"
        aria-labelledby="example-modal-sizes-title-sm"
      >
        <Modal.Body className={styles.alertMsg__modalBody}>
          <div className={styles.alertMsg__img}>
            <StaticImage
              src="../../images/bookPack/tick_alert.png"
              alt="tick_icon"
              className="img-fluid"
              placeholder="blurred"
              quality={90}
            />
          </div>
          <div className={styles.alertMsg__para}>{props.text}</div>
          <div className={styles.alertMsg__crossBtn}>
            <span
              className={`icon-cross`}
              aria-hidden="true"
              role="presentation"
              onClick={props.onHideAlertPopUpModal}
            ></span>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

AlertPopUp.propTypes = propTypes;
AlertPopUp.defaultProps = defaultProps;

export default AlertPopUp;

// These are the steps to follow to call this component in the parent component:-

// ---->> state <<----
// const [showAlertPopUp, setShowAlertPopUp] = useState(false);

// ---->> function <<----
// const handleAlertPopUpModal = () => {
//   // popup modal will show only when all form fields are filled
//   if (isValid) {
//     setShowAlertPopUp(true);
//   }
// };

// ---->> render (onClick Function) <<----
// onClick={() => handleAlertPopUpModal()}

// ---->> render (Modal) <<----
//   /* <AlertPopUp
//   text="Thank you for registering for launch invite! we will contact you soon."
//   showAlertPopUp={showAlertPopUp}
//   onHideAlertPopUpModal={() => setShowAlertPopUp(false)}
// /> */
